import React from 'react';
import styled from 'styled-components';

// Component
import SectionDashboardBigNumberBar from '../../components/section-dashboard-big-number-bar';

// Types
import { WidgetDirection, PieSeriesData } from '../../types';

const StyledBoxContainer = styled.div<{ direction: WidgetDirection }>`
    display: flex;
    flex-direction: ${props => (props.direction === 'horizontal' ? 'row' : 'column')};
    height: 100%;
`;

export type WidgetPieChartBigNumberProps = {
    data: PieSeriesData[];
    direction: WidgetDirection;
    total: number;
    chartLabel?: string;
};

const WidgetPieChartBigNumber = ({ data, direction, total, chartLabel }: WidgetPieChartBigNumberProps) => {
    return (
        <StyledBoxContainer direction={direction}>
            {data.map((dataPoint, index) => {
                const { name, value, color } = dataPoint;
                const percentage = (dataPoint.value / total) * 100;

                return (
                    <SectionDashboardBigNumberBar
                        key={`${name}${index}`}
                        index={index}
                        percentage={percentage}
                        direction={direction}
                        name={name}
                        color={color}
                        value={value}
                        chartLabel={chartLabel}
                    />
                );
            })}
        </StyledBoxContainer>
    );
};

export default WidgetPieChartBigNumber;
